<!-- prettier-ignore -->
<template>
  <div>
    <slot name="btn" v-bind="{ searchFocus, searchBlur, opened, searchInput, selectedOptions, multiple, searchInputElRef, removeOption }">
      <div  class="bg-white relative w-full text-left cursor-default dropdown-button px-2">
          <input type="text" v-model="searchInput.value" :placeholder="searchInput.placeholder" 
            class="form-control inline-flex outline-none ring-0 text-sm placeholder-gray-700 mb-2" :ref="searchInputElRef" @focus="searchFocus" @blur="searchBlur">
      </div>
    </slot>
    <ul 
      :ref="optionsContainerRef" 
      tabindex="-1" 
      role="listbox" 
      :class="ulClass"
    >
      <slot
        name="loading"
        v-if="loading && !showMaxItemsSelected"
      >
        <li>Loading</li>
      </slot>
      <slot
          name="noresults"
          v-bind="{ searchInput, closeSelect }"
          v-if="showNoResults && !loading /*&& !showMaxItemsSelected*/"
      >
        <li class="dropdown-item">Žádný výsledek nenalezen, změnte hledaný výraz</li>
      </slot>
      <slot
          name="maxitems"
          v-bind="{ maxItems }"
          v-if="showMaxItemsSelected"
      >
        <li class="dropdown-item">Můžete vybrat maximálně {{ maxItems }} možností</li>
      </slot>
      <slot
          name="maxresults"
          v-bind="{ searchInput, maxOptions, filteredOptions, resultsCount, filteredAndLimitedOptions }"
          v-if="showMaxResultsExceeded && !loading /*&& !showMaxItemsSelected*/"
      >
        <li class="dropdown-item">Zobrazeno prvních {{ filteredAndLimitedOptions.length }} záznamů z {{ resultsCount }}. Upřesněte hledaný výraz</li>
      </slot>
      <template v-for="(option, optionIndex) in filteredOptions" :key="option.id">
        <slot
          name="option"
          v-bind="{ 
            option, handleMouseEnter, selectOption, interactedAddOption, showMaxItemsSelected,
            highlighted: optionIndex === cursor, 
            selected: value.indexOf(option.id) !== -1,
            optionRef: optionIndex === cursor ? (el) => { this.selectedOptionRef(el); return; } : null
          }"
          v-if="true /*!loading && !showMaxItemsSelected*/"
        >
          <li class="dropdown-item"
            @mouseenter="handleMouseEnter(option)"
            @click.stop="selectOption(option)"
            :ref="optionIndex === cursor ? (el) => { this.selectedOptionRef(el); return; } : null"
          >
            <span class="flex items-center gap-x-2 font-normal px-2 py-0.5 rounded-sm" :class="{  'ring-2 ring-blue-500 ring-offset-1' : optionIndex === cursor,  'bg-blue-100': value.indexOf(option.id) !== -1  }">
              <input type="checkbox" :checked="value.indexOf(option.id) !== -1" />
              <span v-if="option.newOption && interactedAddOption" class="absolute inset-y-0 left-0 flex items-center pl-1.5">
                <aw-icon icon="arrow-repeat" class="animate-spin h-5 w-5 text-white"/>
              </span>
              <template v-if="option.newOption">přidat nový: </template>{{ option.label }}
            </span>
          </li>
        </slot>
      </template>
    </ul>
  </div>
</template>

<!-- prettier-ignore -->
<script>
import AwSelectMixin from '../mixins/awSelect'

export default {
  mixins: [AwSelectMixin],
  props: {
    ulClass: {
      type: String,
      default: 'w-full max-w-full space-y-0.5 overflow-y-auto max-h-64 px-2 py-1'
    }
  },
  computed: {
    filteredOptions () {
      return this.selectedOptions.concat(
        this.optionsStage3.filter((option) => this.value.indexOf(option.id) === -1)
      )
    },
  },
  methods: {
    searchFocus() {
      this.addKeyHandler()
      if (this.searchInputEl) {
        this.searchInputEl.focus()
      }

      this.updateCursorIndex(true)
    },
    searchBlur() {
      this.removeKeyHandler()
      if (this.searchInputEl) {
        this.searchInputEl.blur()
      }

      this.cursor = null
    },

  }
}
</script>
